export default __webpack_public_path__ + "static/media/circleLeft.0cd761b0.png";